export default __webpack_public_path__ + "static/media/demiplane_dark.a659adb1.png";